import React from 'react'
import { useZoomPan } from '@fs/zion-ui'
import { useSlsHighlights, SlsHighlightsContextProvider as SlsHighlightsHookContextProvider } from '@fs/zion-sls'
import { useR2Highlights } from '../r2Provider/R2Context'

const SlsHighlightsContextProvider = ({ children }) => {
  const [{ controllerRef, stageRef, viewerRef }, { set: setZoomPan }] = useZoomPan()

  const {
    displayHighlights,
    displayHighlightsApi,
    splitScreenDisplayHighlights,
    splitScreenDisplayHighlightsApi,
    recordDisplayHighlights,
    recordDisplayHighlightsApi,
    splitScreenRecordDisplayHighlights,
    splitScreenRecordDisplayHighlightsApi,
  } = useR2Highlights()

  const h = useSlsHighlights({
    mainDisplay: displayHighlights,
    mainApi: displayHighlightsApi,
    mainRecordDisplay: recordDisplayHighlights,
    mainRecordApi: recordDisplayHighlightsApi,
    splitScreenDisplay: splitScreenDisplayHighlights,
    splitScreenApi: splitScreenDisplayHighlightsApi,
    splitScreenRecordDisplay: splitScreenRecordDisplayHighlights,
    splitScreenRecordApi: splitScreenRecordDisplayHighlightsApi,
    setZoomPanCb: setZoomPan,
  })

  return (
    <SlsHighlightsHookContextProvider value={{ ...h, zoomPanRefs: { controllerRef, stageRef, viewerRef } }}>
      {children}
    </SlsHighlightsHookContextProvider>
  )
}

export default SlsHighlightsContextProvider
